import { useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';

import { MonitorIcon, MoonIcon, SunIcon } from '../../components/ui/icons';
import {
  THEME_PREFERENCES,
  getPreference,
  setPreference,
  subscribe,
  type ThemePreference,
} from '../../platform/theme';

const MARK = {
  system: MonitorIcon,
  light: SunIcon,
  dark: MoonIcon,
} as const;

/**
 * The three states as one control: the current one is visibly the current one,
 * and switching is a single press rather than opening a list to pick from.
 *
 * Marks rather than words. Three words — "как в системе", "светлая", "тёмная" —
 * ran the width of the side panel for a setting that is touched twice a year,
 * and the panel is the one place on screen where width is scarce. A monitor, a
 * sun and a moon say the same thing in a tenth of the room; the words stay in
 * the tooltip and in what a screen reader announces.
 */
export function ThemeSwitcher() {
  const { t } = useTranslation();
  const preference = useSyncExternalStore(subscribe, getPreference, () => 'system' as const);

  return (
    <div className="theme-switcher" role="group" aria-label={t('theme.label')}>
      {THEME_PREFERENCES.map((option: ThemePreference) => {
        const Mark = MARK[option];
        return (
          <button
            key={option}
            type="button"
            className={option === preference ? 'is-active' : undefined}
            aria-pressed={option === preference}
            aria-label={t(`theme.${option}`)}
            title={t(`theme.${option}`)}
            onClick={() => setPreference(option)}
          >
            <Mark />
          </button>
        );
      })}
    </div>
  );
}
